import React from 'react';
import './footer.css'


export default function Footer() {
    return (
        <div className = "footer">
            <p>
                Created by Akshay Aravind -- Powered by ChatGPT 3.5
            </p>
        </div>
    )
}